import moment from "moment";

export default {
  methods: {
    formatDateMoment(date) {
      return moment(date).startOf("minute").fromNow();
    },
  },
};
